import { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "./AxoisClient";

// Map route paths to readable page names
const PAGE_NAMES = {
  "/": "Landing Page",
  "/login": "Login",
  "/bookmark-data": "Bookmark Data",
  "/analytics": "Analytics",
  "/assumption&methodology": "Assumption & Methodology",
  "/tariff-matrix": "Tariff Matrix",
  "/detail-view": "Detail View",
};

function getPageName(pathname) {
  return PAGE_NAMES[pathname] || pathname;
}

function PageTracker() {
  const location = useLocation();
  const pageEntryRef = useRef(null);

  const sendTrackingData = useCallback((pageName, pageUrl, enteredAt) => {
    const leftAt = new Date();
    const durationSeconds = Math.round((leftAt - enteredAt) / 1000);

    // Skip if duration is too short (less than 1 second)
    if (durationSeconds < 1) return;

    const payload = {
      page_name: pageName,
      page_url: pageUrl,
      duration_seconds: durationSeconds,
      entered_at: enteredAt.toISOString(),
      left_at: leftAt.toISOString(),
    };

    axiosInstance
      .post("company/page-track", payload)
      .catch(() => {});
  }, []); 

  useEffect(() => {
    // When location changes, send tracking for the previous page
    if (pageEntryRef.current) {
      const { pageName, pageUrl, enteredAt } = pageEntryRef.current;
      sendTrackingData(pageName, pageUrl, enteredAt);
    }

    // Skip tracking for login page
    if (location.pathname === "/login") {
      pageEntryRef.current = null;
      return;
    }

    // Record entry for the new page
    pageEntryRef.current = {
      pageName: getPageName(location.pathname),
      pageUrl: location.pathname,
      enteredAt: new Date(),
    };

    // Send tracking on tab close / browser close
    const handleBeforeUnload = () => {
      if (pageEntryRef.current) {
        const { pageName, pageUrl, enteredAt } = pageEntryRef.current;
        sendTrackingData(pageName, pageUrl, enteredAt);
        pageEntryRef.current = null;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [location.pathname, sendTrackingData]);

  return null;
}

export default PageTracker;
